export default "__VITE_ASSET__74e68419__"